import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../Components/TableHelper";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import Select from "react-select";
import { CheckSquare, Square } from "lucide-react";
import axiosInstance from "../../axiosInterceptor";
import { customStyles } from "../../utils/constant";
import { menuSchema } from "../../Validation/Validation";
import Breadcrumb from "../../Components/Breadcrumb";

const AddMenu = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;
  const [pageData, setPageData] = useState([]);

  useEffect(() => {
    const fetchPageData = async () => {
      try {
        const res = await axiosInstance.get(
          "pageBuilder/getallpagebuilder",
        );
        setPageData(res.data?.data || []);
      } catch (err) {
        setPageData([]);
      }
    };
    fetchPageData();
  }, []);

  const initalvalues = {
    sortOrder: editData?.sortOrder || 1,
    menuName: editData?.menuName || "",
    menuType: editData?.menuType || "",
    menuUrl: editData?.menuUrl || "",
    pageBuilderId: editData?.pageBuilderId || null,
    isActive: editData?.isActive ?? true,
    showInHeader: editData?.showInHeader ?? false,
    showInFooter: editData?.showInFooter ?? false,
    metaTitle: editData?.metaTitle || "",
    metaDescription: editData?.metaDescription || "",
    metaKeywords: editData?.metaKeywords || "",
  };
  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    handleBlur,
    setFieldValue,
    touched,
  } = useFormik({
    initialValues: initalvalues,
    validationSchema: menuSchema,

    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response = editingId
          ? await axiosInstance.put(`/menu/updatemenu/${editingId}`, values)
          : await axiosInstance.post("/menu/createmenu", values);
        if (response.status === 200) {
          toast.success(response.data.message);
          navigator("/menu");
        }
      } catch (error) {
        toast.error(error.response?.data?.message);
        return error;
      } finally {
        setLoading(false);
      }
    },
  });

  const MenuType = [
    { label: "Page", value: "Page" },
    { label: "Home", value: "Home" },
  ];

  const pageBuilderOptions = pageData.map((item) => ({
    label: item.title,
    value: item._id,
  }));

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Menu", path: `/menu` },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} Menu
          </h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="menu-sortOrder"
                        className="col-form-label "
                      >
                        Sort Order
                      </label>
                      <input
                        type="number"
                        className="form-control  border-dark "
                        id="menu-sortOrder"
                        name="sortOrder"
                        placeholder="Enter a sort order"
                        value={values.sortOrder}
                        onChange={handleChange}
                      />
                      {touched.sortOrder && errors.sortOrder && (
                        <small className="text-danger">
                          {errors.sortOrder}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="menu-MenuType"
                        className="col-form-label "
                      >
                        Select Menu Type
                      </label>
                      <Select
                        placeholder=" Select menu type"
                        isClearable
                        styles={customStyles}
                        options={MenuType}
                        value={
                          MenuType.find(
                            (opt) => opt.label === values.menuType,
                          ) || null
                        }
                        onChange={(option) =>
                          setFieldValue(
                            "menuType",
                            option ? option.label : null,
                          )
                        }
                        name="menuType"
                      />
                      {touched.menuType && errors.menuType && (
                        <small className="text-danger">{errors.menuType}</small>
                      )}
                    </div>
                  </div>

                  {(values.menuType === "Page" || values.menuType === "Home" || values.menuType === "Product" || values.menuType === "Project") && (
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="menu-Page" className="col-form-label ">
                          Select Page
                        </label>
                        <Select
                          placeholder=" Select page"
                          isClearable
                          styles={customStyles}
                          options={pageBuilderOptions}
                          value={
                            pageBuilderOptions.find(
                              (opt) => opt.value === values.pageBuilderId,
                            ) || null
                          }
                          onChange={(option) => {
                            setFieldValue(
                              "pageBuilderId",
                              option ? option.value : null,
                            );
                          }}
                          name="pageBuilderId"
                        />
                        {touched.pageBuilderId && errors.pageBuilderId && (
                          <small className="text-danger">
                            {errors.pageBuilderId}
                          </small>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="menuName" className="col-form-label ">
                        Menu Name
                      </label>
                      <input
                        type="text"
                        className="form-control  border-dark "
                        id="menuName"
                        name="menuName"
                        placeholder="Enter a menu name"
                        value={values.menuName}
                        onChange={handleChange}
                      />
                      {touched.menuName && errors.menuName && (
                        <small className="text-danger">{errors.menuName}</small>
                      )}
                    </div>
                  </div>

                  {(values.menuType === "Page" ||
                    values.menuType === "Contact") && (
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label htmlFor="menuUrl" className="col-form-label ">
                            Menu Url
                          </label>
                          <input
                            type="text"
                            className="form-control  border-dark "
                            id="menuUrl"
                            name="menuUrl"
                            placeholder="Enter a menu url"
                            value={values.menuUrl}
                            onChange={handleChange}
                          />
                          {touched.menuUrl && errors.menuUrl && (
                            <small className="text-danger">
                              {errors.menuUrl}
                            </small>
                          )}
                        </div>
                      </div>
                    )}

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="metaTitle" className="col-form-label ">
                        Meta Title
                      </label>
                      <input
                        type="text"
                        className="form-control  border-dark "
                        id="metaTitle"
                        name="metaTitle"
                        placeholder="Enter a meta title"
                        value={values.metaTitle}
                        onChange={handleChange}
                      />
                      {touched.metaTitle && errors.metaTitle && (
                        <small className="text-danger">
                          {errors.metaTitle}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="metaKeywords" className="col-form-label ">
                        Meta Keywords
                      </label>
                      <input
                        type="text"
                        className="form-control  border-dark "
                        id="metaKeywords"
                        name="metaKeywords"
                        placeholder="Enter a meta keywords"
                        value={values.metaKeywords}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.metaKeywords && errors.metaKeywords && (
                        <small className="text-danger">
                          {errors.metaKeywords}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="metaDescription"
                        className="col-form-label"
                      >
                        Meta Description
                      </label>
                      <textarea
                        className="form-control border-dark"
                        id="metaDescription"
                        name="metaDescription"
                        placeholder="Enter a meta description"
                        rows={5}
                        style={{
                          resize: "vertical",
                          minHeight: "45px",
                        }}
                        value={values.metaDescription}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.metaDescription && errors.metaDescription && (
                        <small className="text-danger">
                          {errors.metaDescription}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6 mt-5">
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) => setFieldValue("isActive", val)}
                    />
                  </div>

                  <div className="col-md-6 mt-4">
                    <div
                      className="d-flex flex-column "
                      style={{ gap: "10px" }}
                    >
                      <div
                        className={`menu-row ${values.showInHeader ? "active" : ""
                          }`}
                        onClick={() =>
                          setFieldValue("showInHeader", !values.showInHeader)
                        }
                      >
                        {values.showInHeader ? (
                          <CheckSquare size={20} className="icon-active" />
                        ) : (
                          <Square size={20} className="icon" />
                        )}

                        <span className="menu-title">Show In Header</span>
                      </div>
                      <div
                        className={`menu-row ${values.showInFooter ? "active" : ""
                          }`}
                        onClick={() =>
                          setFieldValue("showInFooter", !values.showInFooter)
                        }
                      >
                        {values.showInFooter ? (
                          <CheckSquare size={20} className="icon-active" />
                        ) : (
                          <Square size={20} className="icon" />
                        )}
                        <span className="menu-title">Show In Footer</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="text-start mt-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>

                  <Link to="/menu">
                    <Button color="danger mx-2">Cancel </Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddMenu;
